export default {
    "name": "Inventory",
    "kind": "HoudiniQuery",
    "hash": "9d3344f684031b99f64936c672f243d043ea3f99ead36eb19dd4cd95a6828904",

    "raw": `query Inventory($inventorySerialId: Int!) {
  inventorySerial(id: $inventorySerialId) {
    number
    inventory {
      id
      skuNumber
      storeId
    }
    id
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "inventorySerial": {
                "type": "InventorySerial",
                "keyRaw": "inventorySerial(id: $inventorySerialId)",
                "nullable": true,

                "selection": {
                    "fields": {
                        "number": {
                            "type": "String",
                            "keyRaw": "number",
                            "visible": true
                        },

                        "inventory": {
                            "type": "Inventory",
                            "keyRaw": "inventory",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "skuNumber": {
                                        "type": "UInt",
                                        "keyRaw": "skuNumber",
                                        "visible": true
                                    },

                                    "storeId": {
                                        "type": "UInt",
                                        "keyRaw": "storeId",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true,
                            "nullable": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "inventorySerialId": "Int"
        },

        "types": {},
        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=9add170af7491d9d4a3a64f40800d6b5451deb22c794e4cbfd69d6c1dd0dae70";